export const detectGenderFromProfile = (text) => {
    if (!text) return 'neutral';

    // Convert to lowercase for easier matching, but keep original for context if needed
    const lower = text.toLowerCase();

    // Look for explicit labels often found in medical profiles
    // e.g. "Sex: Male", "Gender: Female", "Demographics: 45 year old male"
    const explicitMale = /\b(sex|gender|demographics)[^:\n]*:\s*(male|man|boy|gentleman)\b/i;
    const explicitFemale = /\b(sex|gender|demographics)[^:\n]*:\s*(female|woman|girl|lady)\b/i;

    if (explicitMale.test(text)) return 'male';
    if (explicitFemale.test(text)) return 'female';

    // Fallback: Word count heuristics
    // Count pronouns and gendered terms
    const maleCount = (lower.match(/\b(he|him|his|mr\.|male|man)\b/g) || []).length;
    const femaleCount = (lower.match(/\b(she|her|hers|mrs\.|ms\.|female|woman)\b/g) || []).length;

    if (maleCount > femaleCount) return 'male';
    if (femaleCount > maleCount) return 'female';

    return 'neutral';
};

export const getVoiceGender = (voice) => {
    if (!voice || !voice.name) return 'unknown';

    const name = voice.name.toLowerCase();

    // Explicit markers
    if (name.includes('female') || name.includes(' woman') || name.includes('girl')) return 'female';
    if (name.includes('male') || name.includes(' man') || name.includes('boy')) return 'male';

    // Known names (Common in macOS, Windows, Android for en-GB)
    const knownFemales = ['kate', 'serena', 'moira', 'tessa', 'fiona', 'hazel', 'susan', 'catherine', 'martha', 'amy', 'emma', 'rosie'];
    const knownMales = ['daniel', 'oliver', 'rishi', 'george', 'brian', 'arthur', 'fred', 'simon', 'nathan', 'james'];

    if (knownFemales.some(n => name.includes(n))) return 'female';
    if (knownMales.some(n => name.includes(n))) return 'male';

    return 'unknown';
};
